import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=0c6691ee&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6691ee')) {
      api.createRecord('0c6691ee', component.options)
    } else {
      api.reload('0c6691ee', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=0c6691ee&", function () {
      api.rerender('0c6691ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NRKlMaVceqBU/JS/comp/pricelist.vue"
export default component.exports